export const getNodeData = (state) => state.rx.data;
export const isLoading = (state) => state.rx.loading;
export const getInternetStatus = (state) => state.rx.data.internet;
